/**
 * Helpers for nav groups nested more than one level deep (a group whose child is itself
 * a group has no page of its own).
 */

/** First descendant with a real route. An explicit `to` wins. */
export const firstLeafPath = (item: any): string | undefined => {
  if (item?.to) return item.to;
  const child = item?.child?.[0];
  if (!child) return item?.path;
  return child.child ? firstLeafPath(child) : child.path;
};

/** Depth-first list of the leaf entries under a group, for the hover flyouts. */
export const flattenChildren = (children: any[] = []): any[] =>
  children.flatMap(child => (child.child ? flattenChildren(child.child) : [child])).filter(c => c?.sidebarProps);

/**
 * Is this entry the one the current URL is on?
 *
 * Exact match by default; routes with `matchPrefix: true` stay selected on their sub-pages.
 */
export const isRouteSelected = (item: any, pathname: string): boolean =>
  item?.matchPrefix ? pathname.startsWith(item.path) : pathname === item?.path;
